// Şifreleme ve çözme için basit bir Base64 yöntemi
function utf8ToBase64(str: string): string {
  return btoa(unescape(encodeURIComponent(str)));
}

function base64ToUtf8(str: string): string {
  return decodeURIComponent(escape(atob(str)));
}



export function encryptData<T>(data: T): string {
    return utf8ToBase64(JSON.stringify(data));
}

export function decryptData<T>(data: string): T | null {
    try {
        return JSON.parse(base64ToUtf8(data)) as T;
    } catch (error) {
        console.error("Failed to decrypt data:", error);
        return null;
    }
}

// Create or Update
export function setEncryptedItem<T>(key: string, value: T): void {  
    const encryptedValue = encryptData(value);
    if (typeof window !== 'undefined') {
        localStorage.setItem(key, encryptedValue);
    }
}

// Read
export function getEncryptedItem<T>(key: string): T | null {
    if (typeof window === 'undefined') {
        return null;
    }
    const encryptedValue = localStorage.getItem(key);
    if (encryptedValue) {
        return decryptData<T>(encryptedValue);
    }
    return null;
}

// Delete
export function removeEncryptedItem(key: string): void {
    localStorage.removeItem(key);
}

// Usage examples
// setEncryptedItem('user', { name: 'John Doe', age: 30 });
// const user = getEncryptedItem<{ name: string; age: number }>('user');
// console.log(user); // { name: 'John Doe', age: 30 }
// removeEncryptedItem('user');
